import React from 'react';
import cx from 'classnames';

import './index.scss';

const getFirstCharecter=(business_name)=>{
    if(business_name && business_name.length>0){
        return business_name.charAt(0)
    }
    return 'T'
}
const Dentalbody = ({message,logo,business_name,actioncolor,brandcolor,usermessage,emailInit, email_capture_message}) => {
  return (
                 <div className="preview-body">
                            <div className="bot-message">
                            {logo? (<img className="business-logo" src={logo} />):(<div className="business-char">{getFirstCharecter(business_name)}</div>)}
                                <div className="message">Have a question or need help scheduling? Provide your name and number and we’ll text you from our text support line!</div>
                            </div>
                            <div className="user-form-message">
                                <div className="user-form">
                                    <div><label className="label">NAME</label><input className="form-input" type="text"/></div>
                                    <div className="pad-top10"><label className="label">PHONE NUMBER</label><input className="form-input" type="text" value="+1"/></div>
                                    <div className="disclaimer">By submitting you agree to receiving support via text messages at the number provided.</div>
                                    <button className="action-btn" style={{backgroundColor:actioncolor}}>TEXT ME</button>
                                </div>
                            </div>
                        </div>
  );
};

export default Dentalbody;
